/**
 * Generates a unique ID string
 * @returns A unique string ID
 */
export function generateId(): string {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
}
